<div
  [id]="id()"
  role="switch"
  tabindex="0"
  class="tumbler-wrapper non-selectable relative rounded-2xl flex justify-between items-center px-2 cursor-pointer focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-purple"
  [class]="small() ? 'w-15 h-6.25 py-2' : 'w-18 h-9 py-0'"
  (keydown.enter)="onToggleKey($event)"
  (keydown.space)="onToggleKey($event)"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp()"
  (pointercancel)="onPointerCancel()"
>
  <div
    #tumbler
    class="absolute left-0 rounded-full flex justify-center items-center"
    [class]="thumbClasses()"
    [style.transform]="thumbTransform()"
    [style.transition]="dragOffset() === null ? null : 'none'"
  >
    <img
      [src]="selectedOption().image"
      [tooltip]="literalService.get(selectedOption().descriptionKey, true)"
      class="selected w-5 h-5"
      [class]="selectedIconClass()"
      [class.transparent]="!showIcons()"
      draggable="false"
      alt=""
      aria-hidden="true"
    />
  </div>
  <img
    [src]="otherOption().image"
    [tooltip]="literalService.get(otherOption().descriptionKey, true)"
    class="w-5 h-5 filter-neutrals-grey-04 absolute top-1/2 -translate-y-1/2 transparent"
    [class.visible]="showIcons()"
    [class.right-2]="!secondOption()"
    [class.left-2]="secondOption()"
    draggable="false"
    alt=""
    aria-hidden="true"
  />
</div>
